import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router";
import {SzBox, SzButton, SzIcon, SzModal, SzTypographie} from "@suezenv/react-theme-components";
import {formatDateWithDay, formatLocalDateTime} from "../../../main/utils";
import {routesPath} from "../../../routes";
import { displayValues } from "../../store/tools";
import ViewEventManager from "../../manager/ViewEventManager";
import {WATERING_FUNCTIONAL_TYPE} from "../../../main/store/constants";
import AlarmCommentAdd from "./AlarmCommentAdd";
import "./style.scss";

const AlarmRow: any = (props: any) => {
    const {t} = useTranslation();
    const {alarm, equipment, commentSubmitHandler, alarmSelectHandler, alarmSelected, onClickEventDisplayHandler} = props;
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const history = useHistory();
    const toMapHandle = (alarm: any) => {
        const selectedLocationReference = {
            locationReference: {
                sigId: alarm.locationReferenceSigId,
                id: alarm.locationReferenceId,
                name: alarm.locationReferenceName,
            },
            filterWateringEquipment: false,
        };
        props.filterMapLocationReference(selectedLocationReference);
        history.push(alarm.functionalType === WATERING_FUNCTIONAL_TYPE ? routesPath.map : routesPath.hydriqueMap);
    };

    return (
        <>
            <SzModal title={""} show={showEvents} handleClose={() => setShowEvents(false)} size={"xl"}>
                {equipment && <ViewEventManager equipment={equipment}/>}
            </SzModal>
            <SzModal title={""} show={showCommentModal} handleClose={() => setShowCommentModal(false)} size={"lg"}>
                <AlarmCommentAdd
                    closeHandle={() => setShowCommentModal(false)}
                    commentSubmitHandler={commentSubmitHandler}
                    alarm={alarm}
                />
            </SzModal>
            <SzBox className="row alarm-table-row">
                <div className="row col-3 border-right">
                    <div className="row col-5">
                        <SzIcon variant="line" icon="time-clock-circle-1"/>
                        <div className="col-8">
                            <SzTypographie color="inactive" variant="caption" className="m-0">{t("alarm:list.detection")}</SzTypographie>
                            <SzTypographie>{formatLocalDateTime(alarm.startAt)}</SzTypographie>
                        </div>
                    </div>
                    <div className="row col-3">
                        <SzTypographie>{(alarm.acked === true) ? t("alarm:list.alarmAcked") : t("alarm:list.alarmNotAcked")}</SzTypographie>
                    </div>
                    <div className="row col-4">
                        <SzTypographie>{t(`alarm:types.${alarm.type}`)}</SzTypographie>
                    </div>
                </div>
                <div className="row col-6 border-right">
                    <div className="row col-3 alarm-location-reference">
                        <SzTypographie color="inactive" variant="caption" className="m-0">{alarm.locationReferenceName}</SzTypographie>
                        <SzTypographie>{alarm.locationReferenceSigId}</SzTypographie>
                        {alarm.locationReferenceSigId && <div title={t("alarm:btn.map")}>
                            <SzButton
                                variant="secondary"
                                icon="maps-pin-1"
                                onClick={() => toMapHandle(alarm)}
                            ></SzButton>
                        </div>
                        }
                    </div>
                    <div className="row col-6 alarm-equipment-details">
                        <SzTypographie color="inactive" variant="caption" className="m-0">{t("alarm:list.equipment_serial_numbr")}</SzTypographie>
                        <SzTypographie>{`${alarm.equipmentName} / ${alarm.equipmentSerialNumber}`}</SzTypographie>
                        <div className="details-container">
                            <div title={t("equipment:list.btn_journal_title")}>
                                <SzButton onClick={() => onClickEventDisplayHandler(alarm, equipment)} variant="secondary" className="m-0" icon="calendar-3" alignIcon="right"></SzButton>
                            </div>
                            <div className="alarm-equipment-status">
                                <div>{t("equipment:list.status_title")} :</div>
                                <div className={`info-status status-${equipment ? equipment.status.toLowerCase() : ''}`}></div>
                            </div>
                        </div>
                    </div>
                    <div className="row col-3 alarm-event-description">
                        <pre>{displayValues(alarm.values)}</pre>
                        <SzButton className={`alarm-add-comment-btn ${alarm?.comment?.length ? 'alarm-has-comment-btn' : null}`} onClick={() => setShowCommentModal(true)} variant="secondary">Commentaires</SzButton>
                    </div>
                </div>
                <div className="row col-2 border-right">
                    <div className="row col-6 alarm-acked-by">
                        <SzTypographie>{alarm.ackUserName}</SzTypographie>
                    </div>
                    <div className="row col-6">
                        <SzTypographie>{formatLocalDateTime(alarm.ackedAt)}</SzTypographie>
                    </div>
                </div>
                <div className="row col-1">
                    {
                        alarm.acked === false && (
                            <div className="alarm-checkbox-container">
                                <label className="alarm-checkbox">
                                    <input type="checkbox" checked={alarmSelected} onChange={() => alarmSelectHandler(alarm.id)} />
                                    <span className="checkmark"></span>
                                </label>
                            </div>
                        )
                    }
                </div>
            </SzBox>
        </>
    );
};

export default AlarmRow;
